<template>
    <div class="group-travel-room-data">
        <p>{{ roomTypeName }}</p>
        <div class="input-fields">
            <div class="input-fields__content">
                <div class="label-input booking-field">
                    <select :value="value.adults.length" @input="$event => setAdultCount($event.target.value)">
                        <option :value="0" v-text="translations.input.adults"></option>
                        <option v-for="n in 6" :value="n" :key="'adult_count_' + n">{{ n }} {{ (n > 1) ? 'voksne' : 'voksen'
                        }}
                        </option>
                    </select>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 395.65 223" class="icon-dropdown">
                        <path
                            d="M370.5,0a25,25,0,0,0-17.79,7.37L210.57,149.51l-12.73,12.73-12.73-12.73L43,7.37A25.16,25.16,0,1,0,7.38,43L180,215.63a25.16,25.16,0,0,0,35.58,0L388.29,43A25.17,25.17,0,0,0,370.5,0Z"
                            style="fill: rgb(140, 140, 130);"></path>
                    </svg>
                </div>
                <div class="label-input booking-field">
                    <select :value="value.children.length" @input="$event => setChildrenCount($event.target.value)">
                        <option :value="0" v-text="translations.input.children"></option>
                        <option v-for="n in 6" :value="n" :key="'chil_count_' + n">{{ n }} {{ (n > 1) ? 'børn' : 'barn' }}
                        </option>
                    </select>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 395.65 223" class="icon-dropdown">
                        <path
                            d="M370.5,0a25,25,0,0,0-17.79,7.37L210.57,149.51l-12.73,12.73-12.73-12.73L43,7.37A25.16,25.16,0,1,0,7.38,43L180,215.63a25.16,25.16,0,0,0,35.58,0L388.29,43A25.17,25.17,0,0,0,370.5,0Z"
                            style="fill: rgb(140, 140, 130);"></path>
                    </svg>
                </div>
            </div>
            <div class="input-fields__content booking-block" v-for="(adultData, adultDataKey) in value.adults"
                :key="`adult_data_key_${adultDataKey}`">
                <div class="input-fields__content">
                    <div class="booking-block__header">
                        <div class="booking-block__header__text">
                            <h2>{{ translations.input.adult }} {{ adultDataKey + 1 }}</h2>
                        </div>
                    </div>
                    <div class="booking-block__content">
                        <div class="label-input booking-field">
                            <select :value="adultData.gender"
                                @input="$event => setAdultData(adultDataKey, { gender: $event.target.value })">
                                <option v-for="(txt, value) in translations.input.sexOptions" :value="value" v-text="txt">
                                </option>
                            </select>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 395.65 223" class="icon-dropdown">
                                <path
                                    d="M370.5,0a25,25,0,0,0-17.79,7.37L210.57,149.51l-12.73,12.73-12.73-12.73L43,7.37A25.16,25.16,0,1,0,7.38,43L180,215.63a25.16,25.16,0,0,0,35.58,0L388.29,43A25.17,25.17,0,0,0,370.5,0Z"
                                    style="fill: rgb(140, 140, 130);"></path>
                            </svg>
                        </div>
                        <input-field :name="translations.input.input_firstname" :value="adultData.firstname"
                            @input="(inp) => setAdultData(adultDataKey, { firstname: inp })"
                            :icon-type="(!adultData.firstname) ? '' : checkmarkIcon"
                            class="booking-field booking-field--firstname"></input-field>
                        <input-field :name="translations.input.input_lastname" :value="adultData.lastname"
                            @input="(inp) => setAdultData(adultDataKey, { lastname: inp })"
                            :icon-type="(!adultData.lastname) ? '' : checkmarkIcon"
                            class="booking-field booking-field--lastname"></input-field>

                        <select-date-picker :yearOffset="adultYearOffset" :yearsToGoBack="shownAdultYears"
                            :value="adultData.birthdate"
                            @input="(inp) => setAdultData(adultDataKey, { birthdate: inp })"></select-date-picker>
                    </div>
                    <msg-block v-for="error in errors.adults[adultDataKey]" type="error">
                        <span><strong v-text="error[0]"></strong></span>
                    </msg-block>
                </div>

            </div>

            <div class="input-fields__content booking-block" v-for="(childData, childDataKey) in value.children"
                :key="`child_data_key_${childDataKey}`">
                <div class="input-fields__content">
                    <div class="booking-block__header">
                        <div class="booking-block__header__text">
                            <h2 class="room-data-person__heading">{{ translations.input.child }} {{ childDataKey + 1 }}</h2>
                        </div>
                    </div>
                    <div class="booking-block__content">
                        <div class="label-input booking-field">
                            <select :value="childData.gender"
                                @input="$event => setChildrenData(childDataKey, { gender: $event.target.value })">
                                <option v-for="(txt, value) in translations.input.childOptions" :value="value" v-text="txt">
                                </option>
                            </select>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 395.65 223" class="icon-dropdown">
                                <path
                                    d="M370.5,0a25,25,0,0,0-17.79,7.37L210.57,149.51l-12.73,12.73-12.73-12.73L43,7.37A25.16,25.16,0,1,0,7.38,43L180,215.63a25.16,25.16,0,0,0,35.58,0L388.29,43A25.17,25.17,0,0,0,370.5,0Z"
                                    style="fill: rgb(140, 140, 130);"></path>
                            </svg>
                        </div>
                        <input-field :name="translations.input.input_firstname" :value="childData.firstname"
                            @input="(inp) => setChildrenData(childDataKey, { firstname: inp })"
                            :icon-type="(!childData.firstname) ? '' : checkmarkIcon"
                            class="booking-field booking-field--firstname"></input-field>
                        <input-field :name="translations.input.input_lastname" :value="childData.lastname"
                            @input="(inp) => setChildrenData(childDataKey, { lastname: inp })"
                            :icon-type="(!childData.lastname) ? '' : checkmarkIcon"
                            class="booking-field booking-field--lastname"></input-field>

                        <select-date-picker :yearOffset="childYearOffset" :yearsToGoBack="shownChildYears"
                            :value="childData.birthdate"
                            @input="(inp) => setChildrenData(childDataKey, { birthdate: inp })"></select-date-picker>
                    </div>

                    <msg-block v-for="error in errors.children[childDataKey]" type="error">
                        <span><strong v-text="error[0]"></strong></span>
                    </msg-block>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import InputField from './../input-field.vue';
import SelectDatePicker from './../datepicker/select-date-picker.vue';
import Validate from 'validate.js';
import MsgBlock from './../msg-block.vue';

const DefaultPerson = {
    gender: 'Frau',
    firstname: '',
    lastname: '',
    birthdate: ''
}

export default {
    props: {
        roomTypeName: {
            type: String,
            default: ''
        },
        value: {
            type: Object,
            default() {
                return {}
            }
        }
    },
    data() {
        return {
            checkmarkIcon: 'checkmark',
            errors: {
                adults: [],
                children: []
            },
            adultYearOffset: APP_CONFIG.MAX_AGE_CHILDREN * -1,
            childYearOffset: 1,
            shownAdultYears: 100,
            shownChildYears: APP_CONFIG.MAX_AGE_CHILDREN + 2,
            translations: APP_CONFIG.TRANSLATION.GROUP_TRAVELS
        }
    },
    watch: {
        valid(valid) {
            this.update({ valid });
        }
    },
    created() {
        this.$parent.$on('submit', this.updateErrors)
    },
    beforeDestroy() {
        this.$parent.$off('submit', this.updateErrors)
    },
    methods: {
        setAdultData(key, data) {
            let adults = Object.assign([], this.value.adults);
            if (adults[key]) {
                adults[key] = Object.assign({}, adults[key], data);
                this.update({ adults });
            }
        },
        setChildrenData(key, data) {
            let children = Object.assign([], this.value.children);
            if (children[key]) {
                children[key] = Object.assign({}, children[key], data);
                this.update({ children });
            }
        },
        setAdultCount(count) {
            this.update({
                adults: this.updatePersonArrayToCount(
                    this.value.adults,
                    count
                )
            });
        },
        setChildrenCount(count) {
            this.update({
                children: this.updatePersonArrayToCount(
                    this.value.children,
                    count
                )
            });
        },
        updatePersonArrayToCount(personList, count) {
            let list = Object.assign([], personList);
            if (list.length > count) {
                list.splice(count);
            } else {
                do {
                    list.push(DefaultPerson);
                } while (list.length < count)
            }

            return list;
        },
        update(data) {
            this.$emit('input', Object.assign({}, this.value, data));
        },
        updateErrors() {
            this.errors = {
                adults: this.adultValidationErrors,
                children: this.childValidationErrors
            }
        }
    },
    computed: {
        valid() {
            return (
                !this.adultValidationErrors.filter((error) => error).length &&
                !this.childValidationErrors.filter((error) => error).length
            ) ? true : false
        },
        personValidation() {
            return {
                firstname: {
                    presence: {
                        allowEmpty: false,
                        message: this.translations.ERRORS.traveller_firstname
                    }
                },
                lastname: {
                    presence: {
                        allowEmpty: false,
                        message: this.translations.ERRORS.traveller_lastname
                    }
                },
                birthdate: {
                    presence: {
                        allowEmpty: false,
                        message: this.translations.ERRORS.traveller_birthdate
                    }
                },
            }
        },
        adultValidationErrors() {
            return this.value.adults.map((adult) => {
                return Validate(adult, this.personValidation, { fullMessages: false });
            })
        },
        childValidationErrors() {
            return this.value.children.map((adult) => {
                return Validate(adult, this.personValidation, { fullMessages: false });
            })
        }
    },
    components: {
        InputField,
        SelectDatePicker,
        MsgBlock
    }
}
</script>